import { render, staticRenderFns } from "./Activity3_1.vue?vue&type=template&id=46470380&scoped=true&"
import script from "./Activity3_1.vue?vue&type=script&lang=js&"
export * from "./Activity3_1.vue?vue&type=script&lang=js&"
import style0 from "./Activity3_1.vue?vue&type=style&index=0&id=46470380&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46470380",
  null
  
)

export default component.exports